import { Chip, css, styled } from '@mui/material';

export const StyledAutocompleteChip = styled(Chip)(
  ({ theme }) => css`
    margin-right: 8px !important;
    &.MuiChip-colorPrimary {
      background: ${theme.palette.primary.light};
      color: ${theme.palette.primary.main};
    }
    & .MuiChip-label {
      font-size: 10px;
      font-weight: 700;
    }
    & .MuiChip-deleteIcon {
      color: ${theme.palette.primary.main};
      :hover {
        color: ${theme.palette.rose[600]};
      }
    }
  `
);
